
import clienteAxios from "../config/axios";

export const getAllEpp = async () => {
    return clienteAxios.get('/epp');
};
export const addEpp = async (epp) => {
    return await clienteAxios.post('/epp',{epp});
}
export const updateEpp = async (epp) => {
    return await clienteAxios.put(`epp/${epp.id}`,{epp});
}
export const deleteEpp = async (eppID,tDocID) => {
    return await clienteAxios.delete(`epp/${eppID}`,{data: {tDocID:tDocID}});
}
